/* yoclay-cache-bust 20260904133839 */
/**
 * YoClay Pocket Pack Builder — packs 1/3/6 (Salva Tédio, Pets, Botânicos).
 * Adiciona cada pocket ao carrinho. Desconto progressivo: Yampi no checkout;
 * o tema só exibe o desconto visual no carrinho (yoclay-pack-pricing.js).
 */
(function () {
  if (typeof window === 'undefined') return;

  var PACK_PROPERTY = 'Pack YoClay';
  var PACK_FLAG = '_yoclay_pack';

  function isEmbedMode(builder) {
    if (builder && builder.getAttribute('data-yoclay-embed') === 'true') return true;
    return document.body && document.body.getAttribute('data-yoclay-embed') === 'true';
  }

  function shopOrigin() {
    if (window.yoclayKitEmbed && window.yoclayKitEmbed.shopOrigin) {
      return String(window.yoclayKitEmbed.shopOrigin).replace(/\/$/, '');
    }
    return window.location.origin;
  }

  function absoluteStoreUrl(path) {
    if (!path) return shopOrigin() + '/cart';
    if (String(path).indexOf('http') === 0) return path;
    return shopOrigin() + (path.charAt(0) === '/' ? path : '/' + path);
  }

  function navigateAfterAdd(url) {
    var target = absoluteStoreUrl(url);
    try {
      if (window.top !== window.self) {
        window.top.location.assign(target);
      } else {
        window.location.assign(target);
      }
    } catch (e) {
      window.open(target, '_top');
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
      } catch (e) {
        /* fallback */
      }
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function pocketKitMessage(required, selected) {
    if (selected < required) {
      return (
        'Selecione mais ' +
        (required - selected) +
        ' pocket' +
        (required - selected === 1 ? '' : 's') +
        ' (total: ' +
        required +
        ').'
      );
    }
    if (selected > required) {
      return 'Remova ' + (selected - required) + ' pocket(s). O pack permite apenas ' + required + '.';
    }
    return '';
  }

  function getSelectedSize(builder) {
    var checked = builder.querySelector('[data-yoclay-pack-size-radio]:checked');
    return checked ? parseInt(checked.value, 10) || 0 : 0;
  }

  function setStep(builder, step) {
    var sizePanel = builder.querySelector('[data-yoclay-pack-step="size"]');
    var pocketsPanel = builder.querySelector('[data-yoclay-pack-step="pockets"]');
    var sizeNav = builder.querySelector('[data-yoclay-pack-step-nav="size"]');
    var pocketsNav = builder.querySelector('[data-yoclay-pack-step-nav="pockets"]');
    var sizeItem = sizeNav ? sizeNav.closest('.yoclay-pocket-pack-builder__step-item') : null;
    var pocketsItem = pocketsNav ? pocketsNav.closest('.yoclay-pocket-pack-builder__step-item') : null;

    var isSize = step === 'size';
    if (sizePanel) sizePanel.hidden = !isSize;
    if (pocketsPanel) pocketsPanel.hidden = isSize;

    if (sizeItem) {
      sizeItem.classList.toggle('is-active', isSize);
      sizeItem.classList.toggle('is-complete', !isSize);
    }
    if (pocketsItem) {
      pocketsItem.classList.toggle('is-active', !isSize);
      pocketsItem.classList.toggle('is-complete', false);
    }

    if (sizeNav) {
      if (isSize) {
        sizeNav.setAttribute('aria-current', 'step');
      } else {
        sizeNav.removeAttribute('aria-current');
      }
    }
    if (pocketsNav) {
      if (!isSize) {
        pocketsNav.setAttribute('aria-current', 'step');
      } else {
        pocketsNav.removeAttribute('aria-current');
      }
    }

    builder.setAttribute('data-yoclay-pack-current-step', step);
    updateStepNavState(builder);
  }

  function updateStepNavState(builder) {
    var sizeNav = builder.querySelector('[data-yoclay-pack-step-nav="size"]');
    var pocketsNav = builder.querySelector('[data-yoclay-pack-step-nav="pockets"]');
    var currentStep = builder.getAttribute('data-yoclay-pack-current-step') || 'size';
    var hasSize = getSelectedSize(builder) > 0;

    if (sizeNav) {
      sizeNav.disabled = currentStep === 'size';
      sizeNav.setAttribute('aria-disabled', currentStep === 'size' ? 'true' : 'false');
    }

    if (pocketsNav) {
      var pocketsEnabled = hasSize && currentStep !== 'pockets';
      pocketsNav.disabled = !pocketsEnabled;
      pocketsNav.setAttribute('aria-disabled', pocketsEnabled ? 'false' : 'true');
      var pocketsItem = pocketsNav.closest('.yoclay-pocket-pack-builder__step-item');
      if (pocketsItem) {
        pocketsItem.classList.toggle('is-disabled', !hasSize);
      }
    }
  }

  function goToPocketsStep(builder, syncFn) {
    var size = getSelectedSize(builder);
    if (!size) return false;
    updateRequiredLabels(builder, size);
    setStep(builder, 'pockets');
    if (typeof syncFn === 'function') syncFn();
    var grid = builder.querySelector('.yoclay-pocket-pack-builder__grid');
    if (grid && typeof grid.scrollIntoView === 'function') {
      grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    return true;
  }

  function goToSizeStep(builder, syncFn) {
    setStep(builder, 'size');
    if (typeof syncFn === 'function') syncFn();
    var sizePanel = builder.querySelector('[data-yoclay-pack-step="size"]');
    if (sizePanel && typeof sizePanel.scrollIntoView === 'function') {
      sizePanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function updateRequiredLabels(builder, required) {
    builder.querySelectorAll('[data-yoclay-pack-required]').forEach(function (el) {
      el.textContent = String(required);
    });
    builder.querySelectorAll('[data-yoclay-pack-required-counter]').forEach(function (el) {
      el.textContent = String(required);
    });
    var hint = builder.querySelector('[data-yoclay-pack-hint]');
    if (hint) {
      var noun = builder.getAttribute('data-pack-item-noun') || 'personagem';
      var nounPlural = builder.getAttribute('data-pack-item-noun-plural') || 'personagens';
      var label = required === 1 ? noun : nounPlural;
      hint.innerHTML =
        'Selecione <span data-yoclay-pack-required>' +
        required +
        '</span> ' +
        label;
    }
  }

  function setupPackBuilder(builder) {
    if (!builder || builder.dataset.yoclayPackBuilderReady === 'true') return;
    builder.dataset.yoclayPackBuilderReady = 'true';

    var form = builder.closest('form');
    var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var checkboxes = Array.prototype.slice.call(builder.querySelectorAll('[data-yoclay-pocket-checkbox]:not([disabled])'));
    var errorEl = builder.querySelector('[data-yoclay-pocket-error]');
    var countEl = builder.querySelector('[data-yoclay-pocket-count]');
    var totalWrap = builder.querySelector('[data-yoclay-pack-total]');
    var totalValueEl = builder.querySelector('[data-yoclay-pack-total-value]');
    var packTitle = builder.getAttribute('data-pack-title') || 'Pack YoClay';
    var packHandle = builder.getAttribute('data-pack-handle') || '';
    var isAdding = false;

    function cartUrl() {
      return (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    }

    function addingLabel() {
      return (window.theme && window.theme.strings && window.theme.strings.addingToCart) || 'Adicionando…';
    }

    function requiredCount() {
      return getSelectedSize(builder);
    }

    function selectedCheckboxes() {
      return checkboxes.filter(function (cb) {
        return cb.checked;
      });
    }

    function isValid() {
      var required = requiredCount();
      return required > 0 && selectedCheckboxes().length === required;
    }

    function showError(message) {
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        builder.classList.remove('yoclay-pocket-kit--error');
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
      builder.classList.add('yoclay-pocket-kit--error');
    }

    function updateTotal() {
      var size = requiredCount();
      var pricing = window.yoclayPackPricing;
      var packTotalCents = pricing ? pricing.getPackTotalCents(size, packHandle) : 0;

      if (totalWrap && totalValueEl) {
        if (size > 0 && packTotalCents > 0) {
          totalWrap.hidden = false;
          totalValueEl.textContent = formatMoney(packTotalCents);
        } else {
          var selected = selectedCheckboxes();
          var sum = selected.reduce(function (acc, cb) {
            return acc + (parseInt(cb.getAttribute('data-pocket-price'), 10) || 0);
          }, 0);
          if (selected.length > 0) {
            totalWrap.hidden = false;
            totalValueEl.textContent = formatMoney(sum);
          } else {
            totalWrap.hidden = true;
          }
        }
      }
    }

    function updateCheckboxLimits() {
      var required = requiredCount();
      var count = selectedCheckboxes().length;
      var atMax = count >= required;
      checkboxes.forEach(function (cb) {
        if (!cb.checked && atMax) {
          cb.disabled = true;
          cb.closest('.yoclay-pocket-kit__option').classList.add('yoclay-pocket-kit__option--disabled');
        } else if (cb.getAttribute('data-variant-id')) {
          cb.disabled = false;
          cb.closest('.yoclay-pocket-kit__option').classList.remove('yoclay-pocket-kit__option--disabled');
        }
      });
    }

    function syncAddToCart() {
      var required = requiredCount();
      var count = selectedCheckboxes().length;
      if (countEl) countEl.textContent = String(count);
      builder.classList.toggle('yoclay-pocket-kit--complete', count === required && required > 0);
      updateCheckboxLimits();
      updateTotal();

      var onPocketsStep = builder.getAttribute('data-yoclay-pack-current-step') === 'pockets';
      var valid = onPocketsStep && isValid();
      var msg = onPocketsStep ? pocketKitMessage(required, count) : '';
      showError(valid ? '' : msg);

      if (!addBtn) return;
      if (isAdding) return;
      if (onPocketsStep) {
        addBtn.disabled = !valid;
        if (valid) {
          addBtn.removeAttribute('data-yoclay-pocket-blocked');
        } else {
          addBtn.setAttribute('data-yoclay-pocket-blocked', 'true');
        }
      } else {
        addBtn.disabled = true;
        addBtn.setAttribute('data-yoclay-pocket-blocked', 'true');
      }
    }

    function resetPocketSelection() {
      checkboxes.forEach(function (cb) {
        cb.checked = false;
      });
      syncAddToCart();
    }

    builder.querySelectorAll('[data-yoclay-pack-size-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateRequiredLabels(builder, requiredCount());
        resetPocketSelection();
        updateStepNavState(builder);
      });
    });

    var nextBtn = builder.querySelector('[data-yoclay-pack-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToPocketsStep(builder, syncAddToCart);
      });
    }

    var backBtn = builder.querySelector('[data-yoclay-pack-back]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        goToSizeStep(builder, function () {
          showError('');
          syncAddToCart();
        });
      });
    }

    builder.querySelectorAll('[data-yoclay-pack-step-nav]').forEach(function (navBtn) {
      navBtn.addEventListener('click', function () {
        if (navBtn.disabled) return;
        var target = navBtn.getAttribute('data-yoclay-pack-step-nav');
        if (target === 'pockets') {
          goToPocketsStep(builder, syncAddToCart);
        } else if (target === 'size') {
          goToSizeStep(builder, function () {
            showError('');
            syncAddToCart();
          });
        }
      });
    });

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', syncAddToCart);
    });

    function buildCartItems() {
      var size = requiredCount();
      var packLabel = packTitle + ' — Pack ' + size;
      return selectedCheckboxes()
        .map(function (cb) {
          var variantId = parseInt(cb.getAttribute('data-variant-id'), 10);
          if (!variantId) return null;
          var props = {};
          props[PACK_PROPERTY] = packLabel;
          props[PACK_FLAG] = packHandle || 'kit-salva-tedio';
          props._yoclay_pack_size = String(size);
          return { id: variantId, quantity: 1, properties: props };
        })
        .filter(Boolean);
    }

    function afterAddSuccess() {
      var redirectPath = cartUrl();
      if (isEmbedMode(builder)) {
        navigateAfterAdd(redirectPath);
      } else {
        window.location.assign(redirectPath);
      }
      return Promise.resolve();
    }

    function setAdding(loading) {
      isAdding = loading;
      builder.classList.toggle('yoclay-pocket-pack-builder--adding', loading);
      if (!addBtn) return;

      addBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      var textEl = addBtn.querySelector('[data-add-to-cart-text]');

      if (loading) {
        addBtn.disabled = true;
        if (textEl) {
          if (!addBtn.dataset.yoclayPackPrevLabel) {
            addBtn.dataset.yoclayPackPrevLabel = textEl.textContent.trim();
          }
          textEl.textContent = addingLabel();
        }
        return;
      }

      if (textEl && addBtn.dataset.yoclayPackPrevLabel) {
        textEl.textContent = addBtn.dataset.yoclayPackPrevLabel;
      }
    }

    function addPackToCart(evt) {
      if (isAdding) {
        if (evt) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
        }
        return false;
      }

      if (builder.getAttribute('data-yoclay-pack-current-step') !== 'pockets') {
        if (evt) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
        }
        setStep(builder, 'size');
        return false;
      }

      syncAddToCart();
      if (!isValid()) {
        if (evt) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
        }
        showError(
          'Escolha exatamente ' +
            requiredCount() +
            ' pockets para continuar. ' +
            pocketKitMessage(requiredCount(), selectedCheckboxes().length)
        );
        return false;
      }

      var items = buildCartItems();
      if (!items.length) {
        if (evt) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
        }
        showError('Não foi possível identificar os Pockets selecionados. Atualize a página e tente novamente.');
        return false;
      }

      if (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      setAdding(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) {
              throw body;
            }
            return body;
          });
        })
        .then(function () {
          return afterAddSuccess(requiredCount());
        })
        .catch(function (err) {
          var message =
            (err && (err.description || err.message)) ||
            'Não foi possível adicionar ao carrinho. Verifique a disponibilidade dos Pockets e tente novamente.';
          setAdding(false);
          syncAddToCart();
          showError(message);
        });

      return false;
    }

    if (form) {
      form.addEventListener('submit', addPackToCart, true);
      form.setAttribute('data-yoclay-pack-builder-form', 'true');
    }

    if (addBtn) {
      addBtn.addEventListener(
        'click',
        function (evt) {
          if (builder.getAttribute('data-yoclay-pack-current-step') !== 'pockets') return;
          if (isAdding || addBtn.disabled) return;
          addPackToCart(evt);
        },
        true
      );
    }

    updateRequiredLabels(builder, getSelectedSize(builder) || 6);
    setStep(builder, 'size');
    syncAddToCart();
    setTimeout(syncAddToCart, 0);
  }

  function setupPackBuilders(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document;
    root.querySelectorAll('[data-yoclay-pocket-pack-builder]').forEach(setupPackBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupPackBuilders(document);
    });
  } else {
    setupPackBuilders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupPackBuilders(event.target);
  });

  window.yoclaySetupPocketPackBuilders = setupPackBuilders;
})();
